import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { HelperService } from 'src/app/shared/helpers/helper.service';
import { environment } from 'src/environments/environment';
import { IdentitableButtonEnum } from '../subscription-tables/desktop/subscription-table-desktop.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargeReasonModalComponent } from 'src/app/pages/charge-reason-modal/charge-reason-modal.component';
import { ProductLevel } from '../product-hero/product-hero.component';
import { User } from 'src/app/interfaces/user';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { UserService } from 'src/app/services/user/user.service';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-identibase-plus-page',
  templateUrl: './identibase-plus-page.component.html',
  styleUrls: ['./identibase-plus-page.component.scss'],
})
export class IdentibasePlusPageComponent implements OnInit, OnDestroy {
  public pricingPlans = environment.stripePlans;
  public IdentitableButtonEnum = IdentitableButtonEnum;
  public desktopViewVisible: boolean;
  public buyButtonVisible: boolean = true;
  public user: User;
  public hasIdentibasePlusOption: boolean;
  public hasIdentiAlertOption: boolean;
  public isAuthenticated: boolean;
  public isBrowser: boolean;

  private _subs: Subscription[] = [];
  public productLevels = ProductLevel;

  constructor(
    private _checkoutService: CheckoutService,
    private _logService: LogService,
    private _router: Router,
    private _helperService: HelperService,
    private _breakpointObserver: BreakpointObserver,
    private _modalService: NgbModal,
    private route: ActivatedRoute,
    private membershipOptionsService: MemberShipOptionsService,
    private userService: UserService,
    private authManager: AuthManagerService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    this.isAuthenticated = this.authManager.isAuthenticated;
    if (this.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.user = userResponse;
        this.hasIdentibasePlusOption = this.membershipOptionsService.identiBasePlusAvailable(this.user);
        this.hasIdentiAlertOption = this.membershipOptionsService.identiAlertAvailable(this.user);
      });
    }

    this.handleHeaderElementVisibility();
    if (this.isBrowser) {
      const currentUrl = window.location.search;
      const params = new URLSearchParams(currentUrl);
      const learnValue = params.get('learn')
      if (learnValue !== null && learnValue.toLowerCase() === 'true') {
        this.buyButtonVisible = false;
      }
    }
  }

  ngOnDestroy() {
    this._subs.forEach((it) => it.unsubscribe());
  }

  public buyIdentibasePlusSubscription() {
    const planId = this.pricingPlans.identibasePlus;
    this._checkoutService.checkout([planId]).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      (err) => {
        this._logService.error('an error occured: ', err);
      }
    );
  }

  public buyIdentiAlertSubscription() {
    const planId = this.pricingPlans.identiAlertAnnual;
    this._checkoutService.checkout([planId]).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      (err) => {
        this._logService.error('an error occured: ', err);
      }
    );
  }

  public compareClick() {
    this._helperService.scrollToElementById('subscription-table');
  }

  public navigateToIdentialertPage() {
    this._router.navigate(['/identialert']);
  }

  public navigateToIdentifindPage() {
    this._router.navigate(['/identifind']);
  }

  public onIdentitableButtonClicked(buttonClickedName: string) {
    switch (buttonClickedName) {
      case IdentitableButtonEnum.IdentibasePlusButton:
        this.buyIdentibasePlusSubscription();
        break;
      case IdentitableButtonEnum.IdentialertButton:
        this.navigateToIdentialertPage();
        break;
      case IdentitableButtonEnum.IdentifindButton:
        this.navigateToIdentifindPage();
        break;
    }
  }

  public openChargeModal() {
    this._modalService.open(ChargeReasonModalComponent);
  }

  private handleHeaderElementVisibility() {
    this._subs.push(
      this._breakpointObserver
        .observe(['(min-width: 768px)'])
        .subscribe((state: BreakpointState) => {
          this.desktopViewVisible = state.matches;
        })
    );
  }
}
